import React, { useState } from "react";
import { useParams, NavLink, Outlet } from "react-router-dom";
import { getCourse } from "../api"; // Update the path as needed

export default function Course() {
  const { catId } = useParams();
  const course = getCourse(catId);
  const [favourites, setFavourites] = useState([]);

  const toggleFavourite = (sessionId) => {
    setFavourites((prev) =>
      prev.includes(sessionId)
        ? prev.filter((id) => id !== sessionId)
        : [...prev, sessionId]
    );
  };

  return (
    <>
      <h1>{course?.name} Diploma</h1>
      <ul className="session-list">
        {course?.sessions.map((session) => (
          <li key={session.id}>
            <button onClick={() => toggleFavourite(session.id)}>
              {favourites.includes(session.id) ? "Unfavourite" : "Favourite"}
            </button>
            <NavLink to={session.id}>{session.name}</NavLink>
          </li>
        ))}
      </ul>
      <Outlet />
    </>
  );
}
